import Header from "components/header";
import React from "react";
import ReactDOM from "react-dom/client";
import "styles/globals.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "@fontsource/open-sans";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <main className="h-100 w-100">
      <Header />
      <App />
    </main>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
